import Calendar from './src/'
export default Calendar



// WEBPACK FOOTER //
// ./components/vc-calendar/index.js